// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cus-chat-supervise .cus-chat-supervise-search {\n  margin-bottom: 10px;\n}\n.cus-chat-supervise .el-dialog {\n  min-width: 620px;\n  max-width: 1200px;\n}\n.cus-chat-supervise .el-dialog__title {\n  line-height: 24px;\n  font-size: 16px;\n  font-weight: bold;\n  color: #0f0f0f;\n}\n.cus-chat-supervise .el-dialog__body {\n  padding: 5px 30px 20px !important;\n}\n", ""]);
// Exports
module.exports = exports;
